/**
 * ダウンロードURL
 * @param url リンクのURL
 * @param prefix fileの最初に入れる文字列
 */
// eslint-disable-next-line import/prefer-default-export
export const downloadFromUrl = async (url: string, prefix: string) => {
  const link = document.createElement('a');
  const date = new Date();
  link.href = url;
  link.download = `${prefix}${date.toISOString().split('.')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};